export default __webpack_public_path__ + "static/media/new-updated-home-banner2.85856bc1.png";